import type { UiLocale } from '@translate-ai/shared';

export type LocalizedLabels = { en?: string; ru?: string };

/**
 * Picks the best label for the current UI locale, falling back to the
 * other supported language and finally an empty string.
 */
export function localizeLabel(labels: LocalizedLabels, locale: UiLocale): string {
  return labels[locale] || labels.en || labels.ru || '';
}
